import React from 'react';
import styled from 'styled-components';
import IntroStep from './IntroStep';
import { SPACERS } from '../../../design-system/settings/variables/Spacers';
import { MEDIA_BREAKPOINTS } from '../../../design-system/settings/variables/Breakpoints';
import TrueImpactAnimation from '../../../design-system/base/TrueImpactAnimation';
import { faArrowsSpin, faFileCheck } from '@fortawesome/pro-light-svg-icons';

interface IntroStepsProps {
  reportYear: string;
}

const StyledDiv = styled.div`
  .steps-grid {
    display: flex;
    flex-direction: column;
    gap: ${SPACERS.small};
    justify-content: space-between;
    ${MEDIA_BREAKPOINTS.largerThanMedium} {
      flex-direction: row;
    }
  }
  .next-button-wrapper {
    flex: 1;
    margin-top: 35px;
    .next-button {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const IntroSteps: React.FC<IntroStepsProps> = ({ reportYear }) => {
  return (
    <StyledDiv>
      <div className="steps-grid">
        <TrueImpactAnimation animationDelay={1}>
          <IntroStep
            arrowDirection={'right'}
            className="template"
            heading="Set up template"
            subheading="Social Impacts"
            options={[
              {
                label: 'Program name',
              },
              {
                label: 'Service locations',
              },
              {
                label: 'Key activities',
              },
            ]}
            details={[
              {
                label: 'Impact 1',
              },
              {
                label: 'Impact 2',
              },
              {
                label: 'Impact 3',
              },
            ]}
            time={{
              label: 'One time only',
              duration: '1-2 hours',
            }}
          />
        </TrueImpactAnimation>
        <TrueImpactAnimation animationDelay={1.5}>
          <IntroStep
            reportYear={reportYear}
            arrowDirection={'right'}
            className="report current"
            heading="Annual Impact Report"
            subheading="Add 2024 expected & actual results "
            options={[
              {
                label: 'Use your new template.',
                icon: faFileCheck,
              },
            ]}
            details={[
              {
                label: 'Update 1 (e.g., January)',
                description: 'Forecast expected # of impacts',
              },
              {
                label: 'Update 2 (e.g., December)',
                description: 'Finalize with actual # of impacts',
              },
            ]}
            time={{
              label: 'Each update',
              duration: '15-20 minutes',
            }}
          />
        </TrueImpactAnimation>
        <TrueImpactAnimation animationDelay={2}>
          <IntroStep
            reportYear={parseInt(reportYear) + 1}
            arrowDirection={'redo'}
            className="report next"
            heading="Annual Impact Report"
            subheading="Add 2025 expected & actual results"
            options={[
              {
                label: 'Re-use your template (refresh as needed).',
                icon: faArrowsSpin,
              },
            ]}
            details={[
              {
                label: 'Update 1 (e.g., January)',
                description: 'Forecast expected # of impacts',
              },
              {
                label: 'Update 2 (e.g., December)',
                description: 'Finalize with actual # of impacts',
              },
            ]}
            time={{
              label: 'Each update',
              duration: '15-20 minutes',
            }}
          />
        </TrueImpactAnimation>
      </div>
    </StyledDiv>
  );
};

export default IntroSteps;
